import { applyMiddleware, compose, createStore } from "redux";
import reducers from "../reducers/index";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import logger from "redux-logger";
import thunkMiddleware from "redux-thunk";
import { stateProps } from "../types/index";
import rootSaga from "../sagas/index";

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [routeMiddleware, logger, sagaMiddleware, thunkMiddleware];
const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const saveToLocalStorage = (state: { doctorInfo: stateProps }) => {
  try {
    const serialisedState = JSON.stringify(state);
    localStorage.setItem("persistantState", serialisedState);
  } catch (e) {
    console.warn(e);
  }
};

const loadFromLocalStorage = () => {
  try {
    const serialisedState = localStorage.getItem("persistantState");
    if (serialisedState === null) return undefined;
    return JSON.parse(serialisedState);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
};

export default function configureStore() {
  //const store = createStore(reducers(history), initialState,
  const store = createStore(
    reducers(history),
    loadFromLocalStorage(),
    composeEnhancers(applyMiddleware(...middlewares))
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers/index", () => {
      const nextRootReducer = require("../reducers/index");
      store.replaceReducer(nextRootReducer);
    });
  }

  store.subscribe(() =>
    saveToLocalStorage({ doctorInfo: store.getState().doctorInfo })
  );

  return store;
}

export { history };
